import '../../styles/OpenCase.css';
import { useParams } from "react-router";
import React, { useState, useEffect } from "react";
import CaseItems from "../../components/CaseItems";

function OpenCase() {
    const [allDrop, setAllDrop] = useState([]);
    const [currentItem, setCurrentItem] = useState(null);
    const [reward, setReward] = useState(null);
    const [opening, setOpening] = useState(false);
    const { casename } = useParams();

    const requestGetHeader = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
    };

    useEffect(() => {
        fetch("https://api.industriegaming.fr/api/auth/strass", requestGetHeader)
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const data = isJson && await response.json();
                setAllDrop(data);
            });
    }, []);

    // Tirage pondéré
    function openCaseWeighted() {
        const items = allDrop.map(item => ({
            ...item,
            weight: parseFloat(item.droppercentage.replace(",", "."))
        }));

        const totalWeight = items.reduce((sum, item) => sum + item.weight, 0);
        let random = Math.random() * totalWeight;

        for (const item of items) {
            if (random < item.weight) return item;
            random -= item.weight;
        }
    }

    // Roulette (une seule image qui change)
    const handleOpen = () => {
        if (opening || allDrop.length === 0) return;

        setOpening(true);
        setReward(null);

        const finalItem = openCaseWeighted();
        let ticks = 0;
        let speed = 40;

        const interval = setInterval(() => {
            const randomItem = allDrop[Math.floor(Math.random() * allDrop.length)];
            setCurrentItem(randomItem);
            ticks++;

            // ralentissement progressif
            if (ticks > 40) speed += 10;

            if (ticks > 60) {
                clearInterval(interval);
                setCurrentItem(finalItem);
                setReward(finalItem);
                setOpening(false);
            }
        }, speed);
    };

    return (
        <div className="case-opening-home">
            <div className="case-opening-header">
                <span className="case-opening-name-case">Kilowatt Case</span>
            </div>

            <div className="case-opening-open-box">
                <div className="case-opening-test">
                    <img
                        className={`case-opening-background-case ${opening || reward ? "hidden" : ""}`}
                        src="https://www.csgodatabase.com/images/containers/webp/Kilowatt_Case.webp"
                    />

                    <div className="roulette-window">
                        <div className="roulette-strip">
                            {currentItem && (
                                <img src={currentItem.picture} alt={currentItem.skinname} />
                            )}
                        </div>
                        <div className="indicator"></div>
                    </div>

                    <img
                        className="case-opening-background-opening"
                        src="https://cdnhell.com/head/img/case/rebel/background/background.png"
                    />
                </div>

                {reward && (
                    <div className="reward-card">
                        <h3>🎉 Tu as obtenu :</h3>
                        <p>{reward.weaponname} | {reward.skinname}</p>
                    </div>
                )}

                <div className="case-opening-open-box-button">
                    <div>
                        <button onClick={handleOpen} disabled={opening}>
                            {opening ? "Ouverture..." : "Ouvrir une caisse"}
                        </button>
                        <span>0.50€</span>
                    </div>
                </div>
            </div>

            <div className="case-opening-content-box">
                <div className="case-opening-content-box-text">
                    <i className="fa-solid fa-suitcase"></i>
                    <span>La caisse contient</span>
                </div>

                <CaseItems datas={allDrop} />
            </div>
        </div>
    );
}

export default OpenCase;
